export const ActivePage = Object.freeze({
    Landing: 'landing',
    WebFormChat: 'web-form-chat',
    Loading: 'loading',
    ThankYou: 'thank-you',
})
